import { Component, OnInit, Input } from "@angular/core";
import { UserModel } from "../../../../../models/user/user.model";
import { AuthService } from "../../../../../services/auth.service";
import { BrogliacciService } from "../../../../../services/brogliacci.service";
import { DistinteIncassiService } from "../../../../../services/distinte-incassi.service";
import { LangService } from "../../../../../services/lang.services";
import { UltimaVersioneApplicativoClientService } from "../../../../../services/ultima-versione-applicativo-client.service";
import { Configurations } from "../../../../../core/configurations";
import { ComponentInterface } from "../../models/component.interface";
import { Router } from "@angular/router";
import { DashboardService } from "../../../../../services/dashboard.service";

@Component({
  selector: "app-brogliacci-incassi",
  templateUrl: "./brogliacci-incassi.component.html",
  styleUrls: ["./brogliacci-incassi.component.css"],
})
export class BrogliacciIncassiComponent implements OnInit, ComponentInterface {
  @Input() config;

  user: UserModel;
  isLoading: boolean;
  countBrogliacciDaLavorare: number = 0;
  title: string;
  subtitle: string;

  constructor(
    public _authService: AuthService,
    private _brogliacciService: BrogliacciService,
    private _dashboardService: DashboardService
  ) {
    this.user = this._authService.user;
  }

  ngOnInit() {
    this.isLoading = true;
    this._dashboardService
      .getBloccoSlider(this.config.token)
      .subscribe((blocco) => {
        this.title = blocco.titolo;
        this.subtitle = blocco.sottotitolo;
      });
    this._brogliacciService
      .getBrogliacciAssociabiliList()
      .finally(() => (this.isLoading = false))
      .subscribe((i) => {
        if (i) {
          this.countBrogliacciDaLavorare = i.length;
        } else {
          this.countBrogliacciDaLavorare = 0;
        }
      });
  }

  hasPermission(permName: string) {
    return this._authService.isGranted(permName);
  }

  goTo() {
    // this._router.navigate(["/nuovadistintaversamenti"]);
    window.open("/nuovadistintaversamenti", "_blank");
  }
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/dynamic/components/brogliacci-incassi/brogliacci-incassi.component.ts